export const LOGIN_STATUS_USER_PASSWORD = "USER_PASSWORD";
export const LOGIN_STATUS_LOGGED_IN = "LOGGED_IN";
export const LOGIN_STATUS_ERROR = "ERROR";
export const LOGIN_STATUS_OTP_PIN_DESTS = "OTP_PIN_DESTS";
export const LOGIN_STATUS_OTP_PIN = "OTP_PIN";

export const LOGIN_ACTION_START_SUBMIT = "startSubmit";
export const LOGIN_ACTION_HANDLE_SUBMIT = "handleSubmit";
export const LOGIN_ACTION_FINISH_SUBMIT = "finishSubmit";
export const LOGIN_ACTION_TOKEN_ACTION = "tokenAction";

export const GOOGLE_RECAPTCHA_KEY = "6LcnpUQdAAAAAFTRiEmv2B7IQKwGKjxJ16pCd4pq";
